import React, { FunctionComponent } from 'react';
import { Box } from 'rebass/styled-components';
import { MultilineTextWithEllipsis } from '.';

export interface ElidableTextProps {
  maxWidth?: number;
  lineCount?: number;
  text: string | React.ReactNode;
}

const ElidableText: FunctionComponent<ElidableTextProps> = ({
  maxWidth, lineCount = 0, text,
}: ElidableTextProps) => {
  let maxFirstwordLength = 0;
  let firstWord = '';

  if (typeof text === 'string') {
    // If we cannot smoothly break into multiple lines, just show ellipsis on the first line
    // math here is not meant to be precise. If we want to improve this, we would have to get render
    // size by rendering off screen. Also, there are javascript libraries to help handling ellipses.
    maxFirstwordLength = maxWidth ? maxWidth / 5 : 50;
    [firstWord] = text.split(/\s+/);
  }

  if ((lineCount && lineCount === 1) || typeof text !== 'string' || firstWord.length > maxFirstwordLength) {
    return (
      <Box
        maxWidth={maxWidth}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {text}
      </Box>
    );
  }

  if (lineCount && lineCount > 1) {
    return (
      <MultilineTextWithEllipsis maxWidth={maxWidth} lineCount={lineCount}>
        {text}
      </MultilineTextWithEllipsis>
    );
  }

  return <>{text}</>;
};

export default ElidableText;
